










import { defineComponent } from '@vue/composition-api';

const componentName = 'loading-spinner';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        return {}
    }
})
